import {ChangeDetectionStrategy, Component, HostBinding, inject, input, OnInit} from '@angular/core';
import {StoryblokStylingService} from '@core/services/storyblok-styling.service';
import {
  SearchPageTitleComponent
} from '../../../page/components/search-page/components/search-page-title/search-page-title.component';
import {StoryblokBaseComponent} from '../storyblok-base.component';

@Component({
  selector: 'app-storyblok-image-title',
  templateUrl: './storyblok-image-title.component.html',
  styleUrls: ['./storyblok-image-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SearchPageTitleComponent]
})
export class StoryblokImageTitleComponent extends StoryblokBaseComponent implements OnInit {
  private storyblokStylingService = inject(StoryblokStylingService);


  readonly title = input.required<string>();
  readonly description = input<string>();
  readonly icon = input<any>();
  readonly background_image = input<any>();
  readonly subtitle = input<string>();
  readonly general_styling = input<any>();

  @HostBinding('class') class: any;

  ngOnInit(): void {
    this.class = this.storyblokStylingService.getClassList(this.general_styling(), undefined, {'col-': 12}, this.col());
  }

}
